export default __webpack_public_path__ + "static/media/screen9.1c8781bd.png";